import { formatCurrency } from "@/utils/numberUtils";
import type { FilterChip } from "../../types";
import { DISCOVERED_WITHIN_OPTIONS, INCLUSION_LABELS } from "./options";
import {
  defaultFinancingEventsSlice,
  type FinancingEventsSlice,
} from "./slice";

function chipLabel(slice: FinancingEventsSlice): string {
  const window = DISCOVERED_WITHIN_OPTIONS.find(
    (option) => option.value === slice.discoveredWithinDays
  );
  const parts = [
    INCLUSION_LABELS[slice.inclusionMethod!],
    slice.discoveredWithinDays ? window?.label.toLowerCase() : null,
    slice.financingTypes.length > 0 ? slice.financingTypes.join(", ") : null,
    slice.minAmount != null
      ? `≥ ${formatCurrency(slice.minAmount, true)}`
      : null,
  ];
  return parts.filter(Boolean).join(" · ");
}

export function getChips(
  slice: FinancingEventsSlice,
  setSlice: (slice: FinancingEventsSlice) => void
): FilterChip[] {
  if (!slice.inclusionMethod) return [];

  return [
    {
      id: "financingEvents",
      label: chipLabel(slice),
      filterKey: "financingEvents",
      onRemove: () => setSlice(defaultFinancingEventsSlice),
    },
  ];
}

export function getCount(slice: FinancingEventsSlice): number {
  return slice.inclusionMethod ? 1 : 0;
}
